import moment from 'moment';

// used to push values from model to form
export function formatDatePickerValue(value: any) {
  if (value && new Date(value) instanceof Date) {
    return {
      year: new Date(value).getFullYear(),
      month: new Date(value).getMonth() + 1,
      day: new Date(value).getDate()
    };
  } else {
    return null;
  }
}

export function isFormatted(value: any) {
  return value && value.year && value.month && value.day;
}

// datepicker control values are formatted as
// { year: 1999, month: 01, day: 17 }
// used to push values from form to model
export function parseDatePickerValue(value: any) {
  if (value && value.year && value.month && value.day) {
    return moment(`${value.year}-${value.month}-${value.day}`, 'YYYY-MM-DD').toDate();
  } else {
    return null;
  }
}

// for some date objects such as Effective Date from Earning/Deduction(s)
// the base api doesn't store or return timezone portions of the date objects
// therefore we must treat certain date property(s) as simple strings and ignore the timezone aspects
export function parseDatePickerValueToString(value: any) {
  if (value && value.year && value.month && value.day) {
    return moment(`${value.year}-${value.month}-${value.day}`, 'YYYY-MM-DD').format();
  } else {
    return null;
  }
}

export function parseTimeString(time: string, date: Date = null): Date {
  const timeSplit = time.split(':');
  const hours = parseInt(timeSplit[0]);
  const minutes = parseInt(timeSplit[1]);
  const now = date ?? new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes);
}

export function parseTimeFromDate(date: Date | string): string {
  if (typeof date == 'string') {
    date = new Date(date);
  }
  const minutes = date.getMinutes();
  let minuteText;
  if (minutes < 10) {
    minuteText = `0${minutes}`;
  } else {
    minuteText = `${minutes}`;
  }

  return `${date.getHours()}:${minuteText}`;
}
